<script setup lang="ts">
import { watch, useSlots } from 'vue';
import { Modal } from 'ant-design-vue';

const props = withDefaults(defineProps<{
  title?: string;
  description?: string;
  width?: string | number;
  showHeader?: boolean;
  hideCloseButton?: boolean;
  hideOpenButton?: boolean;
  dismissible?: boolean;
  onCloseBefore?: () => void;
}>(), {
  width: '80%',
  dismissible: true,
});

const open = defineModel<boolean>('open', { default: false });

const onClose = () => { open.value = false; };
const onOpen = () => { open.value = true; };

watch(open, (newVal) => {
  if (!newVal) {
    props.onCloseBefore?.();
  }
});

const slots = useSlots();
</script>

<template>
  <slot name="button" v-bind="{ onOpen }">
    <button
      v-if="!hideOpenButton"
      type="button"
      class="inline-block"
      @click="onOpen"
    >
      <slot name="icon">
        <span class="text-primary">Open</span>
      </slot>
    </button>
  </slot>
  <Modal
    v-model:open="open"
    :width="width"
    :title="showHeader ? title : undefined"
    :closable="!hideCloseButton && !!showHeader"
    :mask-closable="dismissible"
    :keyboard="dismissible"
    :footer="slots.footer ? undefined : null"
  >
    <p v-if="showHeader && description" class="mb-3 text-sm text-gray-500">
      {{ description }}
    </p>
    <slot v-bind="{ onClose, onOpen, open }" />
    <template v-if="slots.footer" #footer>
      <slot name="footer" v-bind="{ onClose, onOpen, open }" />
    </template>
  </Modal>
</template>
